import { render, staticRenderFns } from "./paperScoreSettingList.vue?vue&type=template&id=7ec63566&scoped=true&"
import script from "./paperScoreSettingList.vue?vue&type=script&lang=js&"
export * from "./paperScoreSettingList.vue?vue&type=script&lang=js&"
import style0 from "./paperScoreSettingList.vue?vue&type=style&index=0&id=7ec63566&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec63566",
  null
  
)

export default component.exports